const styles = theme => ({
  root: {
    maxWidth: '100%'
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  buttonBase: {
    display: 'block',
    marginBottom: 16,
    paddingBottom: 8
  },
  passed: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.success
  },
  failed: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.error.main
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.accent,
    color: 'white',
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
  textFieldRoot: {
    margin: theme.spacing.unit,
    '&:focus': {
      outline: 'none'
    }
  },
  textFieldInput: {
    background: theme.palette.primary.contrastText,
    borderRadius: '25px',
    padding: '10px 15px',
    color: theme.palette.primary.light,
  },
  jobsWrapper: {
    maxWidth: '100%',
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: 'block',
  },
  jobOrder: {
    "& svg": {
      fill: "#fff"
    },
    color: "#fff",
    marginRight: 10,
    fontSize: 16,
    borderBottom: '2px solid #fff'
  },
  divContent: {
    height: "100%"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/jobs/styles.js